/* eslint-disable camelcase */
/**
 * axios封装
 * 请求拦截、响应拦截、错误统一处理
 */
import Vue from 'vue'
import axios from 'axios'
import store from '../store/index'
import router from '../router/index'
import { get_, remove_ } from 'utils/tools'//
import { Message } from 'element-ui'

const vm = new Vue()

const CancelToken = axios.CancelToken
const source = CancelToken.source()

let loading

const _axios = axios.create({
  baseURL: process.env.BASE_URL,
  timeout: 100000
})

/**
  * 请求拦截器
  */
_axios.interceptors.request.use(
  config => {
    if (config.url === '/api/guestbook/putguest') {
      startLoading()
    }
    config.cancelToken = source.token
    const token = get_('Ap62vo0l')
    if (token) {
      config.headers = { 'authorization': token }
    }

    store.state.loading = true
    return config
  },
  error => {
    setTimeout(() => {
      store.state.loading = false
    }, 3000)
    // return Promise.reject(error)
    return Promise.reject();
  }
)
/**
      * 响应拦截器
      */
_axios.interceptors.response.use(
  _data => {
    const { code } = _data.data
    if (code === 1) {
      endLoading()
    } else {
      setTimeout(() => {
        endLoading()
      }, 2000)
    }

    // 响应成功关闭loading
    store.state.loading = false
    return _data.data
  },
  error => {
    // console.log(error.response)
      Message({
        // message: error.message || '服务器错误',
        // type: 'error'
      })
      setTimeout(() => {
        endLoading()
        store.state.loading = false
      }, 1000)
        
      return Promise.reject();
      // return Promise.reject(error.message)
    }
  
)

function startLoading () {
  const options = {
    lock: true,
    fullScreen: true,
    text: '正在加载中......',
    background: 'rgba(255, 255, 255, .4)'
  }
  loading = vm.$loading(options)
}

function endLoading () {
  loading && loading.close()
}


export default {
  get (url, params, headers) {
    return new Promise((resolve, reject) => {
      _axios({
        method: 'get',
        url: url,
        params: params,
        headers: headers
      }).then(
        data => {
          // console.log(data)
          // console.log(url.includes('check_settled'))
          if (data.code === 0) {
            // Message({
            //   message: data.msg,
            //   type: 'error'
            // })
          }
          if (url.includes('check_settled')) {
            resolve(data)
          } else {
            resolve(data.data)
          }
        }
      ).catch(err => {
        reject(err)
      })
    })
  },
  get_ (url, params, headers) {
    // 用户获取图片验证码等接口用
    return new Promise((resolve, reject) => {
      _axios({
        method: 'get',
        url: url,
        params: params,
        headers: headers
      }).then(res => {
        resolve(res.data)
      }).catch(err => {
        reject(err)
      })
    })
  },
  post (url, params, headers) {
    return new Promise((resolve, reject) => {

      //处理的原因是因为后端不识别json(后端可配置)
      let data = new FormData();
      for (let i in params) {
        data.append(i, params[i]);
      }

      _axios({
        method: 'post',
        url: url,
        data,
        headers: {
          'Content-Type': 'application/json;charset=UTF-8',
          ...headers
        }
      }).then(
        res => {
          // console.log(res)
          if (res.code === 1) {
            // Message({
            //   message: res.msg,
            //   type: 'success'
            // })
            resolve(res.data)
          } else if (res.code === 0) {
            // Message({
            //   message: res.msg,
            //   type: 'error'
            // })
            resolve(res.data)
          }
        }
      ).catch(err => {
        reject(err)
      })
    })
  },
  put (url, params) {
    return new Promise((resolve, reject) => {
      _axios({
        method: 'put',
        url: url,
        data: params
      }).then(
        res => {
          if (res.code === 1) {
            Message({
              message: res.msg,
              type: 'success'
            })
            resolve(res.data)
          }
        }
      ).catch(err => {
        reject(err)
      })
    })
  },
  delete (url, params) {
    return new Promise((resolve, reject) => {
      _axios({
        method: 'delete',
        url: url,
        data: params
      }).then(
        res => {
          if (res.code === 1) {
            Message({
              message: res.msg,
              type: 'success'
            })
            resolve(res.data)
          }
        }
      ).catch(err => {
        reject(err)
      })
    })
  }
}
